export class UrlPattern {
  name: string = ''
  readonly #pattern: RegExp

  constructor(pattern: RegExp, name: string) {
    this.#pattern = pattern
    this.name = name
  }

  eq(other: string): boolean {
    return other.match(this.#pattern) !== null
  }
}
